import { ProductSource } from '@getvim-core-apps/organizations';
import { Insurer } from '@getvim-os/standard';
import { AppPatient } from '../types';

export const insurerToSource: Record<Insurer, ProductSource> = {
  united_health_care: ProductSource.UnitedHealthCare,
  anthem_blue_cross_ca: ProductSource.AnthemBlueCross,
  premera_blue_cross: ProductSource.PremeraBlueCross,
  blue_cross_blue_shield_fl: ProductSource.BlueCrossBlueShield,
  cigna: ProductSource.Cigna,
  humana: ProductSource.Humana,
  'mock-demo-insurer': ProductSource.MockDemoInsurer,
  'mock-payer': ProductSource.MockDemoInsurer,
  centene: ProductSource.Centene,
  elevance: ProductSource.Elevance,
  optuminsights: ProductSource.OptumInsight,
};

const supportedSources: ProductSource[] = [ProductSource.UnitedHealthCare];

export function checkPatientEligibility(patient: AppPatient) {
  if (!patient) {
    return false;
  }
  const hasToken = patient?.patientSourceVaultToken;

  const isEligible = !!(
    hasToken &&
    patient?.insurance?.insurer &&
    supportedSources?.includes(insurerToSource[patient?.insurance?.insurer])
  );
  return isEligible;
}
